export const Bian_zh = {
    bian: {
        oneMinutes:"1分钟",
        minutes3:"3分钟",
        minutes5:"5分钟",
        minutes15:"15分钟",
        minutes30:"30分钟",
        hours1:"1小时",
        hours2:"2小时",
        hours4:"4小时",
        hours6:"6小时",
        hours8:"8小时",
        hours12:"12小时",
        day:"1天",
        day3:"3天",
        weekly:"周线",
        selectCycle:"选择周期",
        month:"月线",
        open:"开",
        high:"高",
        low:"低",
        closed:"收",
        volume:"成交量",
        assets:"资产",
        interval:"间隔",
        month1:"1个月",
        introduce:"介绍",
        Real:"实时数据",
        details:"每日交易详情 数据展示",
        date:"日期",
        buy:"买入数量",
        sell:"卖出数量",
        block:"块高度",
        transaction:"交易价格",
        income:"卖出收益",
        goal:"目标",
        cycle:"K线周期",
        lines:"K线根数",
        kLineCycle:"请选择K线周期",
        scanning:"开始扫描",
        please:"请选择",
        trading:"交易对",
        level:"等级",
        serialNumber:"序号",

    },


};
export const Bian_en = {
    bian: {
        oneMinutes:"1 min",
        minutes3:"3 min",
        minutes5:"5 min",
        minutes15:"15 min",
        minutes30:"30 min",
        hours1:"1h",
        hours2:"2h",
        hours4:"4h",
        hours6:"6h",
        hours8:"8h",
        hours12:"12h",
        day:"1day",
        day3:"3days",
        weekly:"weekly",
        selectCycle:"Select cycle",
        month:"month",
        open:"open",
        high:"high",
        low:"low",
        closed:"closed",
        volume:"volume",
        assets:"assets",
        interval:"interval",
        month1:"1 month",
        introduce:"introduce",
        Real:"Real time data.",
        details:"Daily trading details data display",
        date:"date",
        buy:"Buy the number",
        sell:"Sell quantity",
        block:"Block height",
        transaction:"The transaction price",
        income:"Sell income",
        goal:"Goal",
        cycle:"K line cycle",
        lines:"The number of K line",
        kLineCycle:"Please select the K-line period",
        scanning:"Start scanning",
        please:"Please select a",
        trading:"Trading on",
        level:"level",
        serialNumber:"number",

    },


};